export default function Services() {
  const services = [
    {
      title: 'Planejamento estratégico de marketing',
      icon: 'ri-compass-3-line'
    },
    {
      title: 'Gestão de tráfego pago',
      icon: 'ri-advertisement-line'
    },
    {
      title: 'SEO estratégico e conteúdo',
      icon: 'ri-search-2-line'
    },
    {
      title: 'Landing pages de alta conversão',
      icon: 'ri-pages-line'
    },
    {
      title: 'CRO e otimização de funil',
      icon: 'ri-line-chart-line'
    },
    {
      title: 'Analytics, BI e governança de dados',
      icon: 'ri-database-2-line'
    }
  ];

  return (
    <section className="py-16 sm:py-20 md:py-24 px-4 sm:px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 sm:mb-12 md:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 leading-tight">
            Estrutura completa para sustentar o crescimento
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-white p-6 sm:p-8 rounded-xl border-2 border-gray-100 hover:border-teal-500 hover:shadow-xl transition-all group"
            >
              <div className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-teal-100 rounded-lg mb-4 sm:mb-6 group-hover:bg-teal-600 transition-colors">
                <i className={`${service.icon} text-xl sm:text-2xl text-teal-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 leading-snug">
                {service.title}
              </h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
